import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import MainNavbarReact from './MainNavbarReact';
import TenantMenuReact from '../tenantMenu/TenantMenuReact';
import NotificationsCenterReact from 'modules/ui/notificationsCenter/notificationCards/NotificationsCenterReact';
import UserMenuReact from '../userMenu/UserMenuReact';
import './mainNavbar.scss';
import '../../ui/notificationsCenter/notificationCards/nofiticationCenterReact.scss';
import OnboardingSidebarView from 'modules/onboarding/sidebar/OnboardingSidebarView.html';
import { OnboardingController } from 'modules/onboarding/OnboardingController';
import { BlipSupportFeatures } from 'modules/blipSupport/BlipSupportFeatures';
import { defaultClusterName } from 'app.constants';
const weblinksdictionary = {
    helpCenter: {
        href: 'https://help.blip.ai',
        tracking: 'organization-helpcenter-clicked',
        icon: 'faq',
    },
    academy: {
        href: 'https://academy.blip.ai/',
        tracking: 'organization-academy-clicked',
        icon: 'guide',
    },
    forum: {
        href: 'https://community.blip.ai/',
        tracking: 'organization-community-clicked',
        icon: 'team',
    },
};
const NavBarReact = ({ user, onMenuOpen, $translate, SegmentService, TenantService, ContextProcessorService, BlipService, $location, $state, BLIP_DOMAIN, AccountService2, OnboardingService, SidebarService, StudioService }) => {
    const [weblinks, setWeblinks] = useState(weblinksdictionary);
    const [weblinksCount, setWeblinksCount] = useState(Object.keys(weblinksdictionary).length);
    const handleMenuClick = () => {
        const e = document.getElementById('menuFaq');
        e.open = !e.open;
        if (onMenuOpen) {
            onMenuOpen();
        }
    };
    const openOnboardingSidebar = () => {
        SidebarService.showSidebar({
            template: _jsx(OnboardingSidebarView, {}),
            controller: OnboardingController,
            margin: false,
            position: 'right',
            width: 580,
            id: 'checklist',
        });
        OnboardingService.revokeOnboardingSidebarDismiss();
    };
    const openBlipSupportMfe = () => {
        $state.go('auth.blipSupport');
        const faqMenu = document.getElementById('menuFaq');
        if (faqMenu) {
            faqMenu.open = false;
        }
    };
    const addBlipSupportWeblink = () => {
        setWeblinks(prev => ({
            ...prev,
            blipSupport: {
                tracking: 'organization-blip-support-clicked',
                icon: 'agent',
                callback: openBlipSupportMfe,
            },
        }));
    };
    const addOnboardingWeblink = () => {
        const updatedWeblinks = {
            ...weblinks,
            checklist: {
                tracking: 'organization-checklist-clicked',
                icon: 'resources',
                callback: openOnboardingSidebar,
            },
        };
        setWeblinksCount(Object.keys(updatedWeblinks).length);
        setWeblinks(updatedWeblinks);
    };
    const checkBlipSupportFlag = async () => {
        const blipSupportIsEnabled = await BlipSupportFeatures.isBlipSupportEnabled();
        const clusterName = defaultClusterName.toLowerCase();
        const isEnabled = blipSupportIsEnabled[clusterName] || false;
        if (isEnabled) {
            addBlipSupportWeblink();
        }
    };
    const checkOnboardingSidebar = async () => {
        const showOnboardingSidebar = await OnboardingService.shouldShowOnboardingSidebar(false);
        if (showOnboardingSidebar) {
            addOnboardingWeblink();
        }
    };
    useEffect(() => {
        checkBlipSupportFlag();
    }, []);
    useEffect(() => {
        checkOnboardingSidebar();
    }, [OnboardingService]);
    const handleDropdownWeblinkMouseup = (key) => {
        SegmentService.createOrganizationTrack(weblinks[key].tracking);
        if (weblinks[key].href) {
            window.open(weblinks[key].href, '_blank');
        }
        if (weblinks[key].callback) {
            weblinks[key].callback();
        }
    };
    return (_jsx("div", { className: "main-navbar-content", children: user && (_jsxs("div", { className: "flex items-center justify-content h-100", children: [_jsxs("div", { className: "main-navbar__context-menu w-45 flex items-center h-100", children: [_jsx(TenantMenuReact, { user: user, "$translate": $translate, SegmentService: SegmentService, TenantService: TenantService, ContextProcessorService: ContextProcessorService, BlipService: BlipService }), _jsx("div", { className: "divisor-vertical-contract" }), _jsx(MainNavbarReact, { user: user, AccountService2: AccountService2, ContextProcessorService: ContextProcessorService, TenantService: TenantService, SegmentService: SegmentService, "$translate": $translate, "$location": $location, "$state": $state, BLIP_DOMAIN: BLIP_DOMAIN, StudioService: StudioService })] }), _jsx("div", { className: "brand-logo fl justify-center flex tc w-10", children: _jsx("a", { href: "/", className: "brand-blip-ballon animated bounceIn", children: _jsx("bds-illustration", { type: "brand", name: "blip-ballon-blue-white-horizontal", alt: "navbar.brandLogo.alt", title: "navbar.brandLogo.title" }) }) }), _jsxs("div", { className: "flex items-center justify-end main-navbar__account-menu zindex-header w-45 h-100", children: [_jsx("div", { className: "menu-faq", onClick: handleMenuClick, children: _jsx("bds-icon", { "data-test": "menuIconFaqTest", id: "buttonMenuFaq", class: "round menu-icon icon-faq", name: "question", theme: "outline", "aria-label": "\u00CDcone FAQ" }) }), _jsx("bds-menu", { id: "menuFaq", class: "menu-drop", "data-test": "menuFaqTest", menu: "buttonMenuFaq", position: "left", children: Object.entries(weblinks).map(([key, item], index) => (_jsxs(React.Fragment, { children: [_jsx("bds-menu-action", { "button-text": $translate.instant(`navbar.${key}`), "icon-left": item.icon, lipstick: "false", onClick: () => handleDropdownWeblinkMouseup(key) }), index < Object.keys(weblinksCount).length - 1 && (_jsx("bds-menu-separation", { size: "default" }))] }, key))) }), _jsx(NotificationsCenterReact, { BlipService: BlipService, "$translate": $translate }), _jsx("div", { className: "divisor-vertical" }), _jsx("div", { className: 'h-100', children: _jsx(UserMenuReact, { user: user, "$translate": $translate, "$state": $state }) })] })] })) }));
};
export default NavBarReact;
